import Image from "next/future/image";

import styles from "./Avatar.module.css";

type PropTypes = {
  avatar: string;
  initials?: string;
  size?: number;
  avatar_placeholder_color?: string;
};

const Avatar: React.FC<PropTypes> = ({ avatar, size = 21, initials, avatar_placeholder_color = "" }) =>
  avatar ? (
    <Image width={size} height={size} alt="Avatar" src={avatar} className={styles.avatar} />
  ) : (
    <div
      className={styles.avatarPlaceholder}
      style={
        {
          "--avatar-width": `${size}px`,
          "--avatar-placeholder-color": avatar_placeholder_color,
        } as React.CSSProperties
      }
    >
      {initials}
    </div>
  );
export default Avatar;
